export enum ProcessingVariableEnum {
	VOLUME_TOTAL_COM_CASCA = 'VOLUME_TOTAL_COM_CASCA',
	VOLUME_TOTAL_SEM_CASCA = 'VOLUME_TOTAL_SEM_CASCA',
	VOLUME_INDIVIDUAL_COM_CASCA = 'VOLUME_INDIVIDUAL_COM_CASCA',
	VOLUME_INDIVIDUAL_SEM_CASCA = 'VOLUME_INDIVIDUAL_SEM_CASCA',
	INCREMENTO_MEDIO_ANUAL_COM_CASCA = 'INCREMENTO_MEDIO_ANUAL_COM_CASCA',
	INCREMENTO_MEDIO_ANUAL_SEM_CASCA = 'INCREMENTO_MEDIO_ANUAL_SEM_CASCA',
	AREA_BASAL = 'AREA_BASAL',
	DAP_MAXIMO = 'DAP_MAXIMO',
	DAP_MEDIO = 'DAP_MEDIO',
	DAP_MINIMO = 'DAP_MINIMO',
	DIAMETRO_MEDIO_QUADRATICO = 'DIAMETRO_MEDIO_QUADRATICO',
	ALTURA_DOMINANTE = 'ALTURA_DOMINANTE',
	ALTURA_TOTAL_MAXIMA = 'ALTURA_TOTAL_MAXIMA',
	ALTURA_TOTAL_MEDIA = 'ALTURA_TOTAL_MEDIA',
	ALTURA_TOTAL_MINIMA = 'ALTURA_TOTAL_MINIMA',
	NUMERO_DE_FUSTES = 'NUMERO_DE_FUSTES',
	NUMERO_DE_FUSTES_UTEIS = 'NUMERO_DE_FUSTES_UTEIS',
}
